import { Skeleton } from "@mui/material";
import { Box } from "@mui/system";

const OnlyMobgraphSkel = () => {
  return (
    <Box sx={{ padding: "16px 16px" }}>
      <Skeleton variant="rounded" height={200} sx={{ borderRadius: "8px" }} />
    </Box>
  );
};

export default OnlyMobgraphSkel;
